<template>
    <!-- KPI 행 -->
    <div
        v-if="variant === 'kpi-row'"
        class="stl-kpi-row stl-dashboard-kpi"
        :class="{ 'stl-kpi-row--gas': gasLayout }"
        aria-hidden="true"
    >
        <div v-for="i in kpiCount" :key="i" class="stl-kpi stl-sk-kpi">
            <div class="stl-sk-kpi-top">
                <span class="stl-sk-line stl-sk-line--w38"></span>
            </div>
            <div class="stl-sk-kpi-bottom">
                <span class="stl-sk-line stl-sk-line--w52 stl-sk-line--lg"></span>
                <span class="stl-sk-spark"></span>
            </div>
        </div>
    </div>

    <!-- 상태 스트립 -->
    <section
        v-else-if="variant === 'status-strip'"
        class="stl-status-strip stl-sk-strip"
        :class="{ 'stl-status-strip--all': stripCols === 3 }"
        aria-hidden="true"
    >
        <div class="stl-strip-cell stl-strip-cell--settle stl-sk-strip-cell">
            <span class="stl-sk-line stl-sk-line--w30"></span>
            <span class="stl-sk-line stl-sk-line--w55"></span>
        </div>
        <span class="stl-strip-divider"></span>
        <div class="stl-strip-cell stl-strip-cell--remainder stl-sk-strip-cell">
            <span class="stl-sk-line stl-sk-line--w28"></span>
            <span class="stl-sk-line stl-sk-line--w40 stl-sk-line--md"></span>
        </div>
        <span class="stl-strip-divider"></span>
        <template v-if="stripCols === 4">
            <div class="stl-strip-cell stl-strip-cell--verify stl-sk-strip-cell">
                <span class="stl-sk-line stl-sk-line--w45"></span>
                <span class="stl-sk-line stl-sk-line--w62"></span>
            </div>
            <span class="stl-strip-divider"></span>
        </template>
        <div class="stl-strip-cell stl-strip-cell--quality stl-sk-strip-cell">
            <span class="stl-sk-line stl-sk-line--w42"></span>
            <span class="stl-sk-line stl-sk-line--w48"></span>
        </div>
    </section>

    <!-- 세대별 표 본문 -->
    <div v-else-if="variant === 'table'" class="stl-sk-table" aria-hidden="true">
        <div class="stl-sk-table-head" :data-cols="cols">
            <span v-for="c in cols" :key="'h' + c" class="stl-sk-line" :class="headColClass(c)"></span>
        </div>
        <div v-for="r in rows" :key="'r' + r" class="stl-sk-table-row" :data-cols="cols">
            <span v-for="c in cols" :key="'c' + c" class="stl-sk-line" :class="rowColClass(c, r)"></span>
        </div>
        <div class="stl-sk-table-foot" :data-cols="cols">
            <span v-for="c in cols" :key="'f' + c" class="stl-sk-line" :class="footColClass(c)"></span>
        </div>
    </div>

    <!-- 차트 영역 -->
    <div v-else-if="variant === 'chart'" class="stl-sk-chart" aria-hidden="true">
        <div class="stl-sk-chart-axis"></div>
        <div class="stl-sk-chart-bars">
            <span
                v-for="(h, i) in barHeights"
                :key="i"
                class="stl-sk-bar"
                :style="{ height: h + '%' }"
            ></span>
        </div>
    </div>
</template>

<script>
const CHART_BAR_HEIGHTS = [42, 58, 36, 72, 48, 65, 38, 80, 52, 44, 68, 55];

export default {
    name: "SettlementDashboardSkeleton",
    props: {
        variant: {
            type: String,
            required: true,
            validator: (v) => ["kpi-row", "status-strip", "table", "chart"].includes(v),
        },
        kpiCount: { type: Number, default: 4 },
        gasLayout: { type: Boolean, default: false },
        stripCols: { type: Number, default: 4 },
        rows: { type: Number, default: 6 },
        cols: { type: Number, default: 4 },
    },
    computed: {
        barHeights() {
            return CHART_BAR_HEIGHTS;
        },
    },
    methods: {
        headColClass(c) {
            if (c === 1) return "stl-sk-line--w28";
            return "stl-sk-line--w36 stl-sk-line--num";
        },
        rowColClass(c, r) {
            if (c === 1) return r % 2 ? "stl-sk-line--w32" : "stl-sk-line--w26";
            return r % 3 ? "stl-sk-line--w44 stl-sk-line--num" : "stl-sk-line--w38 stl-sk-line--num";
        },
        footColClass(c) {
            if (c === 1) return "stl-sk-line--w22";
            return "stl-sk-line--w40 stl-sk-line--num";
        },
    },
};
</script>
